import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { User } from '../../types/user.model';

@Component({
  selector: 'mmb-web-app-add-persona-modal',
  templateUrl: './add-persona-modal.component.html',
  styleUrls: ['./add-persona-modal.component.scss']
})
export class AddPersonaModalComponent implements OnInit {
  @Output() addSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();

  @Input() user: User;
  form: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit() {
    this.form = this.fb.group({
      persona: [this.user.credentials ? this.user.credentials.candidate_type_user : '', Validators.required],
    });
  }

  onClose() {
    this.closed.emit();
  }

}
